import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Icon } from 'semantic-ui-react';
import { AttachmentsFromOtherLots } from './AttachmentsFromOtherLots';

export const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: 210,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    boxShadow: state.isFocused && '1px solid #ff5252',
    border: state.isFocused ? '1px solid #ff5252' : '1px solid #e5e5ea',
    minHeight: 48,
    '&:hover': {
      border: state.isFocused && '1px solid #ff5252',
    },
  }),
};
interface Props {
  setSelectedProperty?: (e: any) => void;
  selectedProperty?: any;
  property: any;
  propertyId: any;
  searchTypeId: any;
  setDocumentKey?: () => void;
  showIcon?: boolean;
}

interface GroupedOption {
  label: string;
  options: any;
}
const InfoFromOtherLots = (props: Props) => {
  const [properties, setProperties] = useState<GroupedOption[]>([]);
  const [showActions, setShowActions] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState<any>();
  const [attachmentsKey, setAttachmentsKey] = useState(0);

  const getPropertiesOfOrder = async () => {
    const { data } = await axios.get(`/api/orders/getOrderProperties/${props.property.orderId}`);
    const duplicateOrder = await checkDuplicateOrder(props.property, props.searchTypeId);

    let groupedOptions: GroupedOption[] = [];
    if (data && data.length > 0) {
      const filteredProperties = data.filter((d: any) => d.id !== +props.propertyId);

      groupedOptions.push({
        label: 'Lots',
        options: filteredProperties.map((p: any) => ({
          value: p.id,
          label: p.address + ' ' + p.section + '-' + p.block + '-' + p.lot,
        })),
      });
    }
    if (duplicateOrder) {
      groupedOptions.push({
        label: 'Orders',
        options: [
          {
            label: `${duplicateOrder.hdsNumber} - ${moment(duplicateOrder.savedSearchLastUpdated).format(
              'MM/DD/YYYY'
            )} `,
            value: duplicateOrder.propertyId,
          },
        ],
      });
    }

    setProperties(groupedOptions);
  };
  const checkDuplicateOrder = async (property: any, searchTypeId: number) => {
    const newProperty = {
      address: property.address,
      stateCode: property.stateCode,
      section: property.section,
      block: property.block,
      lot: property.lot,
      qualifier: property.qualifier,
      swisCode: property.swisCode,
      orderId: property.orderId,
      searchTypeId: searchTypeId,
    };

    const { data } = await axios.get('/api/property/DuplicateOrderCheck', {
      params: newProperty,
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
    return data;
  };

  const formatGroupLabel = (data: GroupedOption) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span>{data.label}</span>
      <span
        style={{
          backgroundColor: '#EBECF0',
          borderRadius: '2em',
          color: '#172B4D',
          display: 'inline-block',
          fontSize: 12,
          fontWeight: 'normal',
          lineHeight: '1',
          minWidth: 1,
          padding: '0.16666666666667em 0.5em',
          textAlign: 'center',
        }}
      >
        {data.options.length}
      </span>
    </div>
  );

  useEffect(() => {
    getPropertiesOfOrder();
  }, [props.property]);

  useEffect(() => {
    if (selectedProperty?.value) {
      setAttachmentsKey(attachmentsKey + 2);
    }
  }, [selectedProperty?.value]);

  if (properties.length === 0 || properties.every(p => p.options && p.options.length === 0)) {
    return <div></div>;
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 20 }}>
      <div style={{ width: 200, marginLeft: 8, display: 'flex', flexDirection: 'column', marginTop: -20 }}>
        <span style={{ marginBottom: 8 }}>
          Get info from other lots {props.showIcon && <Icon name="check circle" color="green" />}
        </span>
        <Select
          placeholder="Select a property"
          options={properties}
          formatGroupLabel={formatGroupLabel}
          onChange={e => {
            props.setSelectedProperty && props.setSelectedProperty(e);
            setSelectedProperty(e);
            setShowActions(true);
          }}
          value={selectedProperty}
          styles={customStyles}
        />
        {showActions && (
          <AttachmentsFromOtherLots
            key={attachmentsKey}
            setShowActions={setShowActions}
            propertyId={props.propertyId}
            searchTypeId={props.searchTypeId}
            oldPropertyId={selectedProperty.value}
            setDocumentKey={props.setDocumentKey}
          />
        )}
      </div>
    </div>
  );
};

export default InfoFromOtherLots;
